const TRIGGER = '/';

// The longest short code in use is under 100 characters. Past that the agent is
// writing a sentence, not searching, so the menu closes.
export const MAX_QUERY_LENGTH = 100;

const startsWord = (text, index) =>
  index === 0 || /[\s\0]/.test(text[index - 1]);

// Index of the last '/' before the cursor that starts a word. A '/' inside a
// word (URLs, dates, "and/or", short codes like "Práce/ brigáda") is not one.
const findTrigger = text => {
  let index = text.lastIndexOf(TRIGGER);
  while (index > 0 && !startsWord(text, index)) {
    index = text.lastIndexOf(TRIGGER, index - 1);
  }
  return index !== -1 && startsWord(text, index) ? index : -1;
};

/**
 * Matcher for the canned response menu. Unlike `triggerCharacters`, the search
 * may contain spaces and '/', because most short codes do ("MM Podpis").
 * It must not start with a space, so "a / b" in plain text opens nothing.
 * @param {ResolvedPos} $position - the cursor position
 * @returns {{range: {from: number, to: number}, text: string} | null}
 */
export const cannedResponseMatcher = $position => {
  if (!$position.parent.isTextblock) return null;

  const { doc, pos } = $position;
  const start = $position.start();
  // Inline atoms (mentions, hard breaks) become '\0' so positions stay aligned.
  const textBefore = doc.textBetween(start, pos, '\0', '\0');

  const index = findTrigger(textBefore);
  if (index === -1) return null;

  const query = textBefore.slice(index + TRIGGER.length);
  if (query.includes('\0') || /^\s/.test(query)) return null;

  // Like the other menus, the match covers the rest of the word after the cursor.
  const textAfter = doc.textBetween(pos, $position.end(), '\0', '\0');
  const tail = textAfter.match(/^[^\s\0]*/)[0];

  const text = query + tail;
  if (text.length > MAX_QUERY_LENGTH) return null;

  return {
    range: { from: start + index, to: pos + tail.length },
    text,
  };
};
